import { USAGE_CREDITS_CATEGORY_MAP } from "../../MyAccount/UsageMetrics/constants";

export const CREDIT_PURCHASE_RATES = {
  basic: 1.5,
  advanced: 2,
  specialty: 2.5,
};

const CREDIT_PURCHASE_SHARED_COPY = {
  title: "Test credit limit exceeded",
  subtitle: "You’ve exceeded the test credit limit for the selected plan.",
  payTitle: "Pay for Additional test credits now",
  payDescription:
    "Your monthly subscription won't be affected. Once payment is complete, you can continue with your sample submission",
  secondaryDescription:
    "Your progress will be saved as a draft, and you'll be redirected to Billing",
  secondaryActionLabel: "Select Credit Quantity",
};

export const CREDIT_PURCHASE_VARIANT_COPY = {
  prepaid: {
    ...CREDIT_PURCHASE_SHARED_COPY,
    secondaryTitle: "Purchase More Test Credits",
  },
  subscription: {
    ...CREDIT_PURCHASE_SHARED_COPY,
    secondaryTitle: "Increase the subscription",
  },
};

export const CREDIT_PURCHASE_ROWS = [
  {
    key: "microbiology",
    name: "Microbiology",
    basic: 4,
    advanced: 0,
    specialty: 2,
  },
  {
    key: "chemistry",
    name: "Chemistry",
    basic: 0,
    advanced: 1,
    specialty: 3,
  },
];

export const CREDIT_PURCHASE_TIER_FIELDS = ["basic", "advanced", "specialty"];
export const CREDIT_PURCHASE_CATEGORY_ORDER = ["microbiology", "chemistry"];

export const CATEGORY_TIER_TO_CODE = Object.entries(USAGE_CREDITS_CATEGORY_MAP).reduce(
  (acc, [code, mapping]) => {
    acc[`${mapping.categoryKey}-${mapping.tierName.toLowerCase()}`] = code;
    return acc;
  },
  {},
);
